// Every animated surface in this folder honours it, so it lives here rather than being redeclared in each.
export function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
}
